import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Countries from '../../../services/countries/countries';
import PortalDropdown from '../../portal/portalDropdown';

export default class CountriesDropdown extends Component {

    shouldComponentUpdate(nextProps) {

        if (nextProps.value !== this.props.value ||
                nextProps.errorText !== this.props.errorText ||
                nextProps.floatingLabelText !== this.props.floatingLabelText) {
            
            return true;
        }

        return false;
    }

    render() {

        const countries = Countries.slice();

        countries.unshift({
            id: '-1',
            name: this.props.translations.selectCountry
        });
        
        return (
            <div
                className='portal-countries-dropdown'
            >
                <PortalDropdown
                    items={countries}
                    {...this.props}
                />
            </div>
        );
    }
}

PropTypes.propTypes = {
    countries: PropTypes.array
};


// WEBPACK FOOTER //
// ./src/components/portal/countriesDropdown/index.jsx